import { render } from "./WCCustomizeButton.vue?vue&type=template&id=53e5b8c4&ts=true"
import script from "./WCCustomizeButton.vue?vue&type=script&lang=ts"
export * from "./WCCustomizeButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__